import { withInstall } from '@ll-plus/utils'

import ProTable from './src/table.vue'

export const LlProTable = withInstall(ProTable)
export default LlProTable

export * from './src/config'
export * from './src/hooks'

declare module 'vue' {
  export interface GlobalComponents {
    LlProTable: typeof ProTable
  }
}
